import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable, of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";

export interface BrokerCatalogItem {
  readonly id: number;
  name: string;
  /** Broker slug used by insurance quotes (e.g. "howden", "inter"). */
  key?: string;
  /** Folio display prefix (e.g. "H"). Absent when the broker has no prefix configured. */
  prefix?: string;
}

@Injectable({
  providedIn: "root",
})
export class BrokersService {
  private catalog$: Observable<BrokerCatalogItem[]> | null = null;

  constructor(private http: HttpClientService) {}

  public getBrokers(): Observable<BrokerCatalogItem[]> {
    return this.http.get<BrokerCatalogItem[]>("/api/brokers");
  }

  /**
   * Broker catalog cached for the app session. On error it emits an empty catalog
   * (folio display degrades to the raw folio) and allows a retry on the next call.
   */
  public getBrokersCatalog(): Observable<BrokerCatalogItem[]> {
    if (this.catalog$) {
      return this.catalog$;
    }

    this.catalog$ = this.getBrokers().pipe(
      catchError(() => {
        this.catalog$ = null;
        return of([] as BrokerCatalogItem[]);
      }),
      shareReplay(1)
    );
    return this.catalog$;
  }
}
